<template>
  <div
    v-if="!$_.isEmpty(badgesForShowing(showing))"
    style="display: flex; position: relative; overflow: hidden; min-width: 100px;"
    v-bind="$attrs"
  >
    <div
      class="marquee"
      :class="{ 'current': current }"
      :style="{ 'animation-duration': badgesForShowing(showing).length > 1 ? `${2 * badgesForShowing(showing).length}s` : `${3 * badgesForShowing(showing).length}s` }"
    >
      <showing-badge
        v-for="badge in badgesForShowing(showing)"
        :key="'1-' + badge.id"
        :showing-badge="badge"
        :color="color"
        :size="size"
        class="text-bold q-pa-none bg-transparent"
      />
      <showing-badge
        v-for="badge in badgesForShowing(showing)"
        :key="'2-' + badge.id"
        :showing-badge="badge"
        :color="color"
        :size="size"
        class="text-bold q-pa-none bg-transparent"
      />
      <showing-badge
        v-for="badge in badgesForShowing(showing)"
        :key="'3-' + badge.id"
        :showing-badge="badge"
        :color="color"
        :size="size"
        class="text-bold q-pa-none bg-transparent"
      />
      <showing-badge
        v-for="badge in badgesForShowing(showing)"
        :key="'4-' + badge.id"
        :showing-badge="badge"
        :color="color"
        :size="size"
        class="text-bold q-pa-none bg-transparent"
      />
    </div>
  </div>
</template>

<script>
import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge'
export default {
  name: 'ShowingBadges',
  components: {
    ShowingBadge
  },
  props: {
    showing: {
      type: Object,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: 'white'
    },
    size: {
      type: String,
      required: false,
      default: 'md'
    },
    current: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    badgesForShowing (showing) {
      return _.filter(showing.showingBadges.data, badge => badge.displayOnSignage)
    }
  }
}

</script>

<style scoped>

@keyframes marquee {
    0%   { transform: translate(0, 0); }
    100% { transform: translate(-25%, 0); }
}

.marquee {
  position: absolute;
  left: -25%;
  white-space: nowrap;
  top: -20%;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  height: 100%;
  /* The animation-duration should be overridden */
  animation: marquee 0s linear infinite;
}
.marquee .q-chip{
  height: 100%;
}
.marquee .q-chip:after {
  content: '\A';
  width:5px;
  height:5px;
  border-radius:50%;
  background: white;
  display:inline-block;
  margin:0 0.2vw 0 0.4vw;
}
.marquee.current .q-chip:after {
  content: '\A';
  width:5px;
  height:5px;
  border-radius:50%;
  background: grey;
  display:inline-block;
  margin:0 0.2vw 0 0.4vw;
}

</style>
